import PanelSection from './PanelSection'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selecedRegionId,
    selectedRegionCountryMeta: state.REGIONS.selectedRegionCountryMeta
  }
}

export default withRouter(connect(mapStateToProps)(PanelSection));



// WEBPACK FOOTER //
// ./src/modules/Content/PanelSection/index.js